import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { cartSelector, userSelector } from '../../../store/user/user.selector';
import { TProduct } from '../../../types/Common';
import commafy from '../../../utils/commafyHelper';
import CustomButton from '../../../components/UI/CustomButton';
import { useNavigate } from 'react-router-dom';
import { purchaseUser, userDeposit } from '../../../apis/payment';
import { setSnackbar } from '../../../store/common/common.reducer';
import { clearCart, setUser } from '../../../store/user/user.reducer';
import { privateRoutes } from '../../../configs/routes';
import './summary.scss';
import { getOrgInfo } from '../../../apis/user';

const SummaryCart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { amount = 0 } = useSelector(userSelector);
  const cart = useSelector(cartSelector);

  const [loading, setLoading] = useState<boolean>(false);
  const [depositLoading, setDepositLoading] = useState<boolean>(false);
  const [dataAmount, setDataAmount] = useState<any>(null);
  const { totalPrice, totalPriceWithOff = 0, totalOff } = dataAmount || {};

  const onClickPurchaseUser = () => {
    setLoading(true);
    const data = {
      price: totalPriceWithOff,
      products: cart.map((i: TProduct) => {
        return {
          productId: i.productId,
          quantity: i.quantity || 1,
        };
      }),
    };

    purchaseUser(data)
      .then(() => {
        getOrgInfo().then((res: any) => {
          dispatch(setUser({ amount: res?.amount || 0 }));

          setTimeout(() => {
            dispatch(
              setSnackbar({
                openSnackbar: true,
                message:
                  'خرید شما با موفقیت انجام شد می توانید برای مشاهده به قسمت خرید های من رجوع کنید',
              }),
            );
          }, 500);

          setTimeout(() => {
            dispatch(clearCart());
          }, 1000);

          navigate(privateRoutes.dashboard);
        });
      })
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  const onClickDepositButton = () => {
    setDepositLoading(true);
    userDeposit((totalPriceWithOff - amount) * 10)
      .then((res: any) => window.open(res?.payment_url, '_self'))
      .finally(() => setDepositLoading(false));
  };

  useEffect(() => {
    if (cart && cart.length > 0) {
      let totalPrice = 0;
      let totalPriceWithOff = 0;
      let totalOff = 0;
      cart.forEach((item: TProduct) => {
        const { price, off = 0, quantity = 1 } = item;
        totalPrice = quantity * (totalPrice + price);
        totalPriceWithOff =
          totalPriceWithOff + quantity * (price - Math.floor((price * off) / 100));
        totalOff = totalOff + quantity * Math.floor((price * off) / 100);
      });

      setDataAmount({ totalPrice, totalPriceWithOff, totalOff });
    }
  }, [cart]);

  return (
    <Box className='mainCartContainer'>
      <Box className='rowContainer'>
        <Typography color='text.dark'>{`قیمت محصولات (${cart?.length})`}</Typography>
        <Typography>
          {totalPrice > 0 ? commafy(totalPrice) : 0}
          <span className='unit'>تومان</span>
        </Typography>
      </Box>

      <Box className='rowContainer'>
        <Typography color='text.light' fontSize='small'>
          سود شما از خرید
        </Typography>
        <Typography fontSize='small' color='text.light'>
          {totalOff > 0 ? commafy(totalOff) : 0}
          <span className='unit'>تومان</span>
        </Typography>
      </Box>

      <Divider sx={{ width: '95%' }} />

      <Box className='rowContainer'>
        <Typography color='text.dark'>مبلغ قابل پرداخت</Typography>
        <Typography color='text.main' fontWeight='bold' fontSize='large'>
          {totalPriceWithOff > 0 ? commafy(totalPriceWithOff) : 0}
          <span className='unit'>تومان</span>
        </Typography>
      </Box>

      <Box className='flexCenter' mt={2} width='100%' gap={1}>
        <CustomButton
          fullWidth
          disabled={loading || amount < totalPriceWithOff}
          loading={loading}
          onClick={onClickPurchaseUser}
        >
          پرداخت
        </CustomButton>

        {amount < totalPriceWithOff && (
          <CustomButton
            fullWidth
            disabled={depositLoading}
            loading={depositLoading}
            onClick={onClickDepositButton}
          >
            <Typography>
              شارژ کیف پول{' '}
              <span className='unitDeposit'>{`(${commafy(
                totalPriceWithOff - amount,
              )} تومان)`}</span>
            </Typography>
          </CustomButton>
        )}
      </Box>

      {amount < dataAmount?.totalPriceWithOff && (
        <Typography color='error.main' my={2} width='60%' textAlign='center'>
          موجودی کیف پول شما کم است. برای پرداخت ابتدا بر روی دکمه شارژ کیف پول کلیک نمایید
        </Typography>
      )}
    </Box>
  );
};

export default SummaryCart;
